import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CourierFormDefinition } from '../../../models/courier-form-definition';
import { UntypedFormGroup, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { InteractionEnum } from '../../../enum/interaction.enum';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix, MatPrefix } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { selectShipmentEditorMetric, selectShipmentEditorShipment } from '../../../store/shipment-editor/shipment-editor.state';
import { shipmentEditorPatchForms } from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-courier-form-editor',
    templateUrl: './courier-form-editor.component.html',
    styleUrls: ['./courier-form-editor.component.scss'],
    imports: [ReactiveFormsModule, MatCheckbox, MatFormField, MatLabel, MatInput, MatSuffix, MatPrefix, MatSelect, MatOption, AsyncPipe]
})
export class CourierFormEditorComponent implements OnInit, OnDestroy {

  @Input()
  form: CourierFormDefinition;

  formGroup: FormGroup;
  formSubscription: Subscription;
  stateSubscription: Subscription;

  constructor(private store: Store<AppState>) { }

  metric$: Observable<boolean> = this.store.select(selectShipmentEditorMetric);

  ngOnInit(): void {
      this.formGroup = new FormGroup({});
      this.formGroup.addControl(this.form.code, new FormControl(true));
      this.form.fields.forEach(f => {
          this.formGroup.addControl(f.code, new FormControl(''));
      });
      this.formSubscription = this.formGroup.valueChanges.subscribe(value => {
          this.store.dispatch(shipmentEditorPatchForms({ forms: value }));
      });
      this.stateSubscription = this.store.select(selectShipmentEditorShipment).subscribe(shipment => {
          this.formGroup.patchValue(shipment.courierForms, { emitEvent: false });
      });
  }

  ngOnDestroy(): void {
      if (this.formSubscription) {
          this.formSubscription.unsubscribe();
          this.formSubscription = null;
      }
      if (this.stateSubscription) {
          this.stateSubscription.unsubscribe();
          this.stateSubscription = null;
      }
  }

    userChange(): void {
  }

}
